import {IConfigSchema,} from '@/containers/FdcMilanoVolunteers/resources/config-schema';
import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';
import {getIndicators} from './calculations';

export const configSchema = (submissions: ISubmissionProps[]): IConfigSchema => ({
    title: 'IV. SODDISFAZIONE PER LE ATTIVITA’ SVOLTE NELL’AMBITO DEL PROGETTO “INDOVINA CHI VIENE A CASA”',
    tooltip: 'Il visual mostra il livello di soddisfazione dei volontari per le attività svolte nell’ambito del progetto “Indovina chi viene a casa”. Il valore è pari alla percentuale di volontari che si dichiara soddisfatto delle attività svolte secondo la “Scheda di Monitoraggio per la rilevazione della soddisfazione dei volontari”. Tale valore viene confrontato con il valore atteso che il progetto prevede di raggiungere (70%).',
    type: 'column',
    categories: ['Percentuale di volontari soddisfatti delle attività svolte'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: [getIndicators(submissions)]
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [70]
        },
    ],
});